import { bootstrap } from '@angular/platform-browser-dynamic';
import { disableDeprecatedForms, provideForms } from '@angular/forms';

// Our main component
import { AppComponent } from './app.component';

// Our main routes
import { APP_ROUTER_PROVIDERS } from './app.routes';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {AuthGuard} from './authentication/auth-guard.service';
import { HTTP_PROVIDERS } from '@angular/http';
import {enableProdMode,provide} from '@angular/core';
import {APP_BASE_HREF} from '@angular/common'; 
if (process.env.ENV === 'production') {
  // Production
  enableProdMode();
} 

bootstrap(AppComponent, [
  [HTTP_PROVIDERS],
  APP_ROUTER_PROVIDERS,
  disableDeprecatedForms(),
  provideForms(),
  provide(LocationStrategy, {useClass: PathLocationStrategy}
  ),
  {provide: APP_BASE_HREF, useValue : '/taf2025/'}
  // {provide: APP_BASE_HREF, useValue : '/tafpiv/'}
  // {provide: APP_BASE_HREF, useValue : '/tafregionalreview/'}
])
.catch(err => console.error(err));
 


/** WEBPACK FOOTER **
 ** ./app/main.ts
 **/